



































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { RELATIVE_DATE_PERIODS, RELATIVE_DATE_TIMES } from "@/data/table";
import HasValidation from "@/mixins/HasValidation";

@Component
export default class DateFilter extends Mixins(HasValidation) {
  @Prop({ required: true })
  public value!: string;

  @Prop({ required: true })
  public relative!: boolean;

  @Prop({ default: false })
  public sameLine!: boolean;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: "" })
  public fieldName!: string;

  @Prop({ required: true })
  public fieldId!: string;

  public relativeDatePeriods = RELATIVE_DATE_PERIODS;
  public relativeDateTimes = RELATIVE_DATE_TIMES();

  public dateTime = "-";
  public dateNumber = 1;
  public datePeriod = "days";

  public created() {
    if (!this.relative) {
      return;
    }
    const indexOfUnderscore = this.value.indexOf("_");
    this.dateTime = this.$_.get(this.value, "0", "-");
    this.dateNumber = this.$_.toNumber(
      this.value.substring(1, indexOfUnderscore)
    );
    this.datePeriod = this.value.substring(indexOfUnderscore + 1);
  }

  @Watch("relative")
  public onRelativeChange() {
    this.$emit("input", this.relative ? this.relativeValue : this.$moment());
  }

  @Watch("dateNumber")
  public onDateNumberChange() {
    this.$emit("input", this.relativeValue);
  }

  @Watch("datePeriod")
  public onDatePeriodChange() {
    this.$emit("input", this.relativeValue);
  }

  @Watch("dateTime")
  public onDateTimeChange() {
    this.$emit("input", this.relativeValue);
  }

  public get relativeValue(): string {
    return `${this.dateTime}${this.dateNumber}_${this.datePeriod}`;
  }
}
